import { useQuery } from '@tanstack/react-query';

import { useCategoryTreeItem } from '../categoryTree/useCategoryTreeItem';
import type { CategoryUidaAsset } from '../compat/tvpil';
import { createMissingCategoryError } from '../errors';
import { queryKeys } from '../queryKeys';

import { createMissingCollectionIdError } from './errors';
import { createLogoQueryOptions } from './queryOptions';

export type UseLogoProps = {
  referenceId: string;
};

function getError(category: CategoryUidaAsset | undefined) {
  if (!category) {
    return createMissingCategoryError();
  }

  if (!category.channels?.[0]) {
    return createMissingCollectionIdError();
  }
}

export function useLogo({ referenceId }: UseLogoProps) {
  const category = useCategoryTreeItem(referenceId);
  const collectionId = category?.channels?.[0];
  const categoryError = getError(category);
  const kSql = category?.aggregatedKSQL;

  const {
    data,
    error,
    isLoading: isDataLoading,
    isFetching,
  } = useQuery({
    ...(collectionId ? createLogoQueryOptions({ collectionId, kSql, referenceId }) : { queryKey: queryKeys.disabled }),
    enabled: Boolean(collectionId),
  });

  const isLoading = isDataLoading || isFetching;
  const logo = data?.logo;
  const logoError = categoryError ?? error;

  return {
    logo,
    isLoading,
    error: logoError,
  };
}
